import { ModelProps, PageModel } from '@adobe/aem-react-editable-components';
import { Model } from '@adobe/aem-spa-page-model-manager';

export const imageSrc = (image) => {
  return 'http://localhost:3000/' + image?.default;
};

export const clientSideRunner = (callback: () => unknown) => {
  if (typeof window !== 'undefined') {
    return callback();
  }
};
export const attemptToReload = (pathname: string, retry = 3) => {
  const counter = parseInt(sessionStorage.getItem(pathname) ?? '0');
  sessionStorage.setItem(pathname, `${counter + 1}`);
  if (counter < retry) {
    window.location.reload();
  } else {
    sessionStorage.removeItem(pathname);
    window.location.href = '/404';
  }
};

function transformToCQ(propKey: string) {
  const tempKey = propKey.substring(1);
  return 'cq' + tempKey.substring(0, 1).toUpperCase() + tempKey.substring(1);
}

export const modelToProps = <T = any>(item: Model = {}): (PageModel & ModelProps & T) | undefined => {
  if (!item || !Object.keys(item).length) return;

  const keys = Object.getOwnPropertyNames(item) as Array<keyof Model>;

  const props = Object.fromEntries(
    keys.map((key) => {
      const propKey = key.startsWith(':') ? transformToCQ(key) : key;
      return [propKey, item[key] || ''];
    })
  );

  return props as PageModel & ModelProps & T;
};
